import { render, staticRenderFns } from "./materialList.vue?vue&type=template&id=6f3b10d0&scoped=true"
import script from "./materialList.vue?vue&type=script&lang=js"
export * from "./materialList.vue?vue&type=script&lang=js"
import style0 from "./materialList.vue?vue&type=style&index=0&id=6f3b10d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3b10d0",
  null
  
)

export default component.exports